
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { SearchSelectComponent } from '../search-select.component';
import { UserSelect, UserSelectMode } from '@app/services/modal.model';

@Component({
  selector: 'app-staff-search-select',
  templateUrl: '../search-select.component.html',
  styleUrls: ['../search-select.component.scss'],
})
export class StaffSearchSelectComponent extends SearchSelectComponent implements OnChanges {

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedId'] && this.selectedId.length > 0) {
      let staffList = this.staffList.filter(stf => this.selectedId.some(stfcd => stfcd === stf.stfcd)).map(x => x.name);
      if (this.selectedId.some(x => x === '-1')) {
        staffList.push(`（担当者未割り当て）`);
      }
      this.setListControlValue(staffList);
    } else {
      this.control.setValue([]);
    }
  }
  override onClick(): void {
    let data: UserSelect = {
      mode: UserSelectMode.STAFF,
      multiple: this.multiple,
      selectedId: this.selectedId
    };
    const modalDialog = this.dialog.select(data);
    modalDialog.afterClosed().subscribe((result: string[]) => {
      if (result) {
        const staffList = this.staffList?.filter(stf => result.some(stfcd => stfcd === stf.stfcd)) || [];
        const staffNames = staffList.map(x => x.name);
        if (result.some(x => x === '-1')) {
          staffNames.push(`（担当者未割り当て）`);
        }
        if (this.multiple) {
          this.staffsChange.emit(result);
          this.form.setValue(result);
        } else {
          this.staffChange.emit(staffList[0]);
          this.form.setValue(result[0]);
        }
        this.setListControlValue(staffNames);
      }
    });
  }
}

